import type { EnrichmentPlugin } from '@amplitude/analytics-browser/lib/esm/types'

import { matchPath } from './path-matcher'

const patterns = [
	'/p/dashboard/main',
	'/p/dashboard/ai',
	'/p/dashboard/reports',
	'/p/og/:og/products',
	'/p/og/:og/settings',
	'/p/pc',
	'/p/products',
	'/p/templates/:type',
	'/p/templates/editor',
	'/p/templates/editor/:template',
	'/p/anchor-management',
	'/p/anchor-management/assortment',
	'/p/anchor-management/anchor-approval',
	'/p/anchor-management/anchor-strategy',
	'/p/promo',
	'/p/promo/create',
	'/p/promo/:id',
	'/p/preferences',
	'/p/whatif/scenarios',
	'/p/whatif/sets',
	'/p/whatif/runs',
	'/p/whatif/runs/:scenarioRunSetId/summary',
	'/authenticate',
	'/login',
]

const findPattern = (path?: string) =>
	path ? patterns.find((pattern) => matchPath(pattern, path)) : 'unknown'

export const pageViewTrackingEnrichment = (): EnrichmentPlugin => ({
	name: 'router-tracking-enrichment',
	type: 'enrichment',
	setup: async () => undefined,
	execute: async (event) => {
		if (event.event_type !== '[Amplitude] Page Viewed') {
			// event name format if using Autocapture Pageviews
			return event
		}
		const route = findPattern(event.event_properties?.['[Amplitude] Page Path'])
		event.event_properties = {
			...event.event_properties,
			'Page Route': route,
		}

		return event
	},
})
